import {
    Accordion,
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
    Box,
    ButtonGroup,
    Flex,
    IconButton,
    Stack,
    Text,
    useColorModeValue,
} from "@chakra-ui/react";
import {useIntl} from 'next-intl';
import PropTypes from "prop-types";
import {FiUser as PerSeatIcon, FiUsers as PerFeatureIcon} from "react-icons/fi";
import {MdOutlineAdd as AddIcon, MdOutlineRemove as SubtractIcon} from "react-icons/md";
import {useDispatch, useSelector} from "react-redux";

import {SEATING_MODE} from "../../../constants";
import {
    addToCart as addToCartAction,
    decrementQuantity as decrementQuantityAction,
    selectItemById
} from "../../../redux/draftShoppingCart.slice";

function CategoryItem({
                          categoryItem: {feature, schema_info, event_start: start, event_end: end, item_description},
                          isAddon
                      }) {
    const intl = useIntl();
    const {
        seating_mode: categoryItemType,
        max_occupancy: categoryItemMaxOccupancy,
        name: featureName,
        id: featureId,
        terms_url: featureTerms,
        terms_conditions: featureTermsText,
    } = feature;

    const {
        name: categoryItemName,
        non_refundable: categoryItemPrice,
        schema_description: featureSchemaDescription,
        id: schemaId // schema should be guaranteed as one schema can only be added one time
    } = schema_info

    const dispatch = useDispatch();

    const decrementQuantity = () => {
        dispatch(decrementQuantityAction({schemaId, start, end}))
    }

    const addToCart = () => {
        dispatch(addToCartAction({
            categoryItemName, // gives the pricing schema name
            categoryItemMaxOccupancy, // max occ
            featureId,
            categoryItemType, // per_feature/per_seat
            featureName,
            categoryItemPrice,
            schemaId,
            featureTerms,
            featureTermsText,
            start, // start time of event
            end // end time of event
        }))
    }

    const getCartItemIfPresent = useSelector((state) => selectItemById(state, {schemaId, start, end}))?.cartItemQuantity

    const CategoryItemBG = useColorModeValue('#F9FAFA', '#3D3D3D')

    return (
        <Flex bg={CategoryItemBG} direction='column'>
            <Flex pt={4} pl={4} pr={4} align='center' justify='space-between'>
                <Flex direction='column' pr={2}>
                    <Text fontSize='md' fontWeight="bold"> {categoryItemName} </Text>
                    <Stack direction='row' align='center'>
                        {categoryItemType === SEATING_MODE.PER_SEAT ? <PerSeatIcon size="20px"/> :
                            <PerFeatureIcon size="20px"/>}
                        {categoryItemType === SEATING_MODE.PER_SEAT ?
                            <Text fontSize='md'>1 Guest
                                <Text display='inline' fontSize='xs' color='gray'> per order </Text>
                            </Text>
                            :
                            <Text fontSize='md'>{categoryItemMaxOccupancy} Guests
                                <Text display='inline' fontSize='xs' color='gray'> per order</Text>
                            </Text>
                        }
                    </Stack>
                    <Text fontSize='md' fontWeight="bold"> {intl.formatNumber(categoryItemPrice, {
                        style: 'currency',
                        currency: 'USD'
                    })} </Text>
                </Flex>
                <Stack direction='row' align='center'>
                    <Text fontSize='md' fontWeight="bold">{getCartItemIfPresent || 0}</Text>
                    <ButtonGroup size='sm' isAttached variant='outline'>
                        <IconButton
                            onClick={decrementQuantity}
                            mr='-px'
                            aria-label='Subtract'
                            icon={<SubtractIcon/>}/>
                        <IconButton
                            onClick={addToCart}
                            aria-label='Add'
                            icon={<AddIcon/>}
                        />
                    </ButtonGroup>
                </Stack>
            </Flex>
            <Accordion allowToggle>
                <AccordionItem border='none'>
                    <h2>
                        <AccordionButton>
                            <AccordionIcon/>
                            <Box flex='1' textAlign='left'>
                                Details
                            </Box>
                        </AccordionButton>
                    </h2>
                    <AccordionPanel whiteSpace="pre-line" pb={4}>
                        {item_description || featureSchemaDescription}
                    </AccordionPanel>
                </AccordionItem>
            </Accordion>
        </Flex>
    )
}

CategoryItem.propTypes = {
    categoryItem: PropTypes.shape({
        feature: PropTypes.object.isRequired,
        schema_info: PropTypes.object.isRequired,
        event_start: PropTypes.string.isRequired,
        event_end: PropTypes.string.isRequired,
    }).isRequired,
    isAddon: PropTypes.bool,
}

CategoryItem.defaultProps = {
    isAddon: false
}

export default CategoryItem